import React from 'react'
import { Link } from 'react-router-dom'
import { useSeo } from '../../lib/i18n'

export default function OmOsEn() {
  useSeo({
    title: 'About Us | Borgs Driving School Kalundborg',
    description: 'Learn about Borgs Driving School I/S in Kalundborg. Safe, supportive driving instruction across Western Zealand tailored to each student.',
    lang: 'en',
    pathname: '/en/about-us'
  })

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="font-header text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight">
            About Borgs Driving School I/S
          </h1>
          <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">
            We provide calm, thorough, and supportive driving instruction in Kalundborg and across Western Zealand.
          </p>
        </div>

        {/* Content Section 1: Story & Mission */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="space-y-6">
            <h2 className="font-header text-3xl font-bold text-slate-900">
              Driving licence in a calm environment without stress
            </h2>
            <p className="text-slate-600 text-base leading-relaxed">
              At Borgs Driving School I/S, we believe students learn best in a quiet, encouraging atmosphere. Our instructors have extensive experience teaching both teenagers and adults, including students who may feel nervous or hesitant behind the wheel at the beginning.
            </p>
            <p className="text-slate-600 text-base leading-relaxed">
              We keep our team sizes small so that there is always dedicated time for each student. This results in significantly higher pass rates in both the theory and practical driving tests.
            </p>

            <div className="pt-2 grid grid-cols-2 gap-4">
              <div className="bg-white p-4 border border-slate-200 shadow-sm">
                <i className="fa-solid fa-graduation-cap text-emerald-600 text-2xl mb-2" aria-hidden="true"></i>
                <h4 className="font-header font-bold text-slate-900">Certified Instructors</h4>
                <p className="text-xs text-slate-500 mt-1">High dedication and pedagogical approach.</p>
              </div>
              <div className="bg-white p-4 border border-slate-200 shadow-sm">
                <i className="fa-solid fa-leaf text-emerald-600 text-2xl mb-2" aria-hidden="true"></i>
                <h4 className="font-header font-bold text-slate-900">The Green Profile</h4>
                <p className="text-xs text-slate-500 mt-1">Famous green driving school cars in town.</p>
              </div>
            </div>
          </div>

          <div className="relative overflow-hidden shadow-2xl border border-slate-200 aspect-square sm:aspect-video lg:aspect-square">
            <img
              src="/_assets/om-borgskoereskole-bil.webp"
              alt="Green driving school car and instructor - Borgs Driving School I/S"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Company Info Box */}
        <div className="bg-emerald-900 text-white p-8 sm:p-12 shadow-xl mb-16">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <h2 className="font-header text-3xl font-bold">
              Borgs Driving School I/S · Company Information
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-0 text-left pt-4 divide-y sm:divide-y-0 sm:divide-x divide-emerald-800/80">
              <div className="pb-4 sm:pb-0 sm:pr-6">
                <span className="text-emerald-400 text-xs font-bold uppercase block mb-1">Company</span>
                <strong className="text-white text-base block font-header">Borgs Køreskole I/S</strong>
                <span className="text-xs text-emerald-200">CVR: 43296000</span>
              </div>
              <div className="py-4 sm:py-0 sm:px-6">
                <span className="text-emerald-400 text-xs font-bold uppercase block mb-1">Address</span>
                <strong className="text-white text-base block font-header">Elmegade 19</strong>
                <span className="text-xs text-emerald-200">4400 Kalundborg</span>
              </div>
              <div className="pt-4 sm:pt-0 sm:pl-6">
                <span className="text-emerald-400 text-xs font-bold uppercase block mb-1">Contact</span>
                <strong className="text-white text-base block font-header whitespace-nowrap">
                  <a href="tel:21470187" className="hover:text-emerald-200 transition-colors">21 47 01 87</a> / <a href="tel:23200425" className="hover:text-emerald-200 transition-colors">23 20 04 25</a>
                </strong>
                <a href="mailto:info@borgskoereskole.dk" className="text-xs text-emerald-200 hover:underline whitespace-nowrap">info@borgskoereskole.dk</a>
              </div>
            </div>

            <div className="pt-6">
              <Link
                to="/en/contact"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-emerald-950 font-bold text-sm shadow-md hover:bg-emerald-100 transition-colors"
              >
                <span>Contact us for enrolment</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}
